import { CommonModule, isPlatformBrowser } from '@angular/common';
import { Component, OnInit, OnDestroy, Inject, PLATFORM_ID } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { LoginService } from '../../../../Service/login.service';

@Component({
    selector: 'app-navbar',
    imports: [RouterLink, CommonModule],
    template: `
      <header class="header">
        <a class="navbar-brand d-flex align-items-center" routerLink="/home" (click)="scrollToSection('inicio')">
          <img src="/assets/Logo Finsinfo.svg" alt="Logo" width="200" height="70" class="d-inline-block align-text-top" style="padding-top: 0.25rem;"/>
        </a>
        <button class="hamburger" (click)="toggleMenu()" aria-label="Menú" *ngIf="isMobile">
          <span></span>
          <span></span>
          <span></span>
        </button>
        <div class="nav-links" [class.open]="menuOpen || !isMobile">
          <a class="nav-link" (click)="scrollToSection('quienes-somos'); closeMenu()">Quiénes somos</a>
          <a class="nav-link" (click)="scrollToSection('contactanos'); closeMenu()">Contáctanos</a>
        </div>
        <a class="nav-link" (click)="onLogin($event)">
          Login
          <img src="../assets/images/img_icons8login96_1.png" alt="Login" class="login-icon" >
        </a>
      </header>
    `,
    styles: [
        `
      .header {
        width: 100vw;
        height: 80px;
        background: white;
        display: flex;
        align-items: center;
        justify-content: space-between;
        position: fixed;
        top: 0;
        left: 0;
        z-index: 1051;
        box-shadow: 0 2px 8px rgba(0,0,0,0.05);
        padding: 0 40px;
      }
      .logo {
        height: 60px;
      }
      .nav-links {
        display: flex;
        gap: 40px;
        transition: max-height 0.3s, opacity 0.3s;
      }
      .nav-link {
        font-size: 24px;
        color: #333;
        text-decoration: none;
        cursor: pointer;
        transition: color 0.2s;
        font-family: 'Inria Sans', sans-serif;
      }
      .login-icon {
        height: 40px;
        width: 40px;
        cursor: pointer;
        border-radius: 50%;
        transition: box-shadow 0.2s;
      }
      .login-icon:hover {
        box-shadow: 0 2px 8px rgba(211,190,144,0.3);
      }
      .hamburger {
        display: none;
        flex-direction: column;
        justify-content: center;
        width: 40px;
        height: 40px;
        background: none;
        border: none;
        cursor: pointer;
        padding: 0;
        margin-left: 10px;
      }
      .hamburger span {
        display: block;
        width: 28px;
        height: 4px;
        margin: 4px auto;
        background: #333;
        border-radius: 2px;
        transition: all 0.3s;
      }
      @media (max-width: 991px) {
        .header {
          flex-direction: row;
          height: 60px;
          padding: 10px 10px;
        }
        .hamburger {
          display: flex;
        }
        .nav-links {
          position: absolute;
          top: 60px;
          left: 0;
          width: 100vw;
          background: white;
          flex-direction: column;
          gap: 10px;
          align-items: flex-start;
          padding: 10px 20px;
          max-height: 0;
          overflow: hidden;
          opacity: 0;
          pointer-events: none;
          box-shadow: 0 2px 8px rgba(0,0,0,0.05);
        }
        .nav-links.open {
          max-height: 200px;
          opacity: 1;
          pointer-events: auto;
        }
        .login-icon {
          display: none;
        }
      }
      @media (max-width: 576px) {
        .header {
          flex-direction: row;
          height: 50px;
          padding: 10px 5px;
          min-width: 0;
        }
        .navbar-brand img {
          width: 120px !important;
          height: 40px !important;
        }
        .nav-links {
          gap: 8px;
          padding: 10px 10px;
        }
        .nav-link {
          font-size: 16px;
          padding: 4px 0;
        }
        .login-icon {
          height: 32px;
          width: 32px;
          margin-top: 0;
        }
      }
    `
    ]
})
export class NavbarComponent {
  menuOpen = false;
  isMobile = false;

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private router: Router,
    private loginService: LoginService
  ) {
    if (isPlatformBrowser(this.platformId)) {
      this.checkMobile();
      window.addEventListener('resize', () => this.checkMobile());
    }
  }

  checkMobile() {
    this.isMobile = window.innerWidth <= 991;
    if (!this.isMobile) this.menuOpen = false;
  }

  toggleMenu() {
    this.menuOpen = !this.menuOpen;
  }

  closeMenu() {
    this.menuOpen = false;
  }

  scrollToSection(sectionId: string): void {
    if (isPlatformBrowser(this.platformId)) {
      if (this.router.url !== '/home') {
        this.router.navigate(['/home']).then(() => {
          setTimeout(() => {
            this.smoothScroll(sectionId);
          }, 300);
        });
      } else {
        this.smoothScroll(sectionId);
      }
    }
  }

  private smoothScroll(sectionId: string) {
    let el: HTMLElement | null = document.getElementById(sectionId);

    if (sectionId === 'quienes-somos' && el) {
      const aboutTitle = el.querySelector('.about-title') as HTMLElement;
      if (aboutTitle) {
        el = aboutTitle;
      }
    }

    if (el) {
      const navbarHeight = 80;
      const y = el.getBoundingClientRect().top + window.pageYOffset - navbarHeight;
      window.scrollTo({ top: y, behavior: 'smooth' });
    }
  }

  onLogin(event: Event) {
    event.preventDefault();

    // Verificar si hay un token activo
    const currentToken = this.loginService.getTokenValue();
    if (currentToken) {
      // Si hay token, hacer logout completo y redirigir a home
      console.log('🔄 Clearing previous session and redirecting to home...');
      this.performLogoutAndRedirect();
    } else {
      // Si no hay token, redirigir directamente al login
      this.router.navigate(['/auth/login']).then(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    }
  }

  private performLogoutAndRedirect(): void {
    // Hacer logout del servicio
    this.loginService.logout();

    // Redirigir a home después de un pequeño delay para asegurar que el logout se complete
    setTimeout(() => {
      this.router.navigate(['/home']).then(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        console.log('✅ Redirected to home after logout');
      });
    }, 100);
  }
}



